<script setup>
/**
 * A "Send a link" link someone else opened first (2026-10-20; backend
 * docs/SHARE_PUBLIC_VERSION_SPEC.md D14, SP-L6). The link opens for one
 * person, like a care-package link, so a forwarded copy lands here: kind,
 * plain, nothing of the reading, and one way on.
 */
import '@/assets/fonts/letter/letter-fonts.css'

const emit = defineEmits(['leave'])
</script>

<template>
  <main class="ltp" data-testid="link-taken-page">
    <div class="ltp-card">
      <span class="ltp-seal" aria-hidden="true">✦</span>
      <h1>This one was opened already.</h1>
      <p>A link like this opens for one person, and someone has it now.</p>
      <p class="ltp-soft">If it was meant for you, ask the person who sent it for a new one.</p>
      <button type="button" class="ltp-btn" data-testid="link-taken-home" @click="emit('leave')">Visit Mystic AIda</button>
    </div>
  </main>
</template>

<style scoped>
.ltp {
  min-height: 100dvh; box-sizing: border-box; display: grid; place-items: center;
  padding: 24px 16px calc(32px + env(safe-area-inset-bottom, 0px));
  background: radial-gradient(120% 60% at 50% 0%, #1d0f38 0%, #0d0520 60%);
  font-family: Inter, system-ui, -apple-system, 'Segoe UI', sans-serif; overflow-x: hidden;
}
.ltp *, .ltp *::before, .ltp *::after { box-sizing: border-box; }
.ltp-card {
  width: 100%; max-width: 420px; padding: 34px 26px 28px; border-radius: 22px; text-align: center;
  background: #fbf6ec; color: #2a1845; border: 1px solid #e4d6b8;
  box-shadow: 0 30px 80px -24px rgba(0, 0, 0, .7);
}
.ltp-seal {
  display: grid; place-items: center; width: 48px; height: 48px; margin: 0 auto 18px; border-radius: 50%;
  font-size: 18px; color: #5a3f0f; background: radial-gradient(circle at 35% 30%, #f3d98f, #c9a94e 45%, #8a6a2a 100%);
  box-shadow: 0 6px 16px -6px rgba(138, 106, 42, .7);
}
.ltp h1 {
  margin: 0 0 14px; font: 600 22px/1.3 'Letter Display', 'Cinzel', Georgia, serif; color: #2a1845; overflow-wrap: anywhere; text-wrap: balance;
}
.ltp p { margin: 0 0 8px; text-wrap: balance; font: 500 17px/1.5 'Letter Serif', 'Cormorant Garamond', Georgia, serif; color: #4a3a63; }
.ltp .ltp-soft { color: #6b5a82; }
.ltp-btn {
  display: inline-flex; align-items: center; justify-content: center; min-height: 48px; margin-top: 18px; padding: 10px 26px;
  border-radius: 999px; border: 1.5px solid #cdb8ea; background: none; color: #4e2776;
  font: 600 14px/1.2 Inter, system-ui, sans-serif; letter-spacing: .02em; cursor: pointer;
}
.ltp-btn:focus-visible { outline: 2px solid #7b4bb0; outline-offset: 2px; }
</style>
